import { createSelector } from '@reduxjs/toolkit';
const selectQuickSetup = (state) => state.quickSetup;
export const selectShowQuickSetup = createSelector([selectQuickSetup], (quickSetup) => quickSetup.showQuickSetup);
export const selectUrlToOpenAfterConvoStarted = createSelector([selectQuickSetup], (quickSetup) => quickSetup.urlToOpenAfterStartingConvo);
